import { render } from "./detail-pay-record.vue?vue&type=template&id=045c7f4f&ts=true"
import script from "./detail-pay-record.vue?vue&type=script&lang=ts"
export * from "./detail-pay-record.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__